import React, {ReactElement} from 'react';
import ReactDOM from 'react-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PuppyCard from "./card/puppy-card";

const PuppyCardSlider: React.FC<any> = (data: any): ReactElement => {
  const {puppies} = data;

  const settings = {
    infinite: false,
    slidesToShow: 4,
    rows: 1,
    speed: 500,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: puppies.length > 4,
          centerMode: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <>
      <Slider
        {...settings}
      >
        {puppies.map((puppy: any) => {
          return (
            <div key={puppy.id}>
              <div className="react-puppy-card">
                <PuppyCard
                  puppydata={puppy}
                />
              </div>
            </div>
          );
        })}
      </Slider>
    </>
  );
};

export default PuppyCardSlider;

if (document.getElementsByClassName('react-puppy-card-slider').length > 0) {
  document.querySelectorAll('.react-puppy-card-slider')
    .forEach((element) => {
      const puppies = JSON.parse(element.getAttribute('data-puppies') || '[]');
      // reset class list to react-puppy-card-slider, to avoid style conflicts
      element.classList.value = 'react-puppy-card-slider';
      ReactDOM.render(<PuppyCardSlider puppies={puppies} />, element);
    });
}
